import api from "./api";

const UsertoOrganizationService ={

    getAllUserToOrganization() {
        return api.get(`/api/v1/userToOrganization`)
    },

    createUserToOrganization(data) {
        return api.post(`/api/v1/userToOrganization`, data)
    },

    updateUserToOrganizationStatus(UserToOrganizationId,statusId) {
        return api.put(`/api/v1/userToOrganization/${UserToOrganizationId}/statusUpdate/${statusId}`)
    },
    
    updateOrganization(userToOrganizationId,data) {
        return api.put(`/api/v1/userToOrganization/${userToOrganizationId}`,data)
    },

    deleteOrganization(userToOrganizationId) {
        return api.delete(`/api/v1/userToOrganization/${userToOrganizationId}`)
    },

    getUserToOrganizationId(userToOrganizationId) {
        return api.get(`/api/v1/userToOrganization/${userToOrganizationId}`)
    }


}

export default UsertoOrganizationService;